import { render, staticRenderFns } from "./DevPageKD1.vue?vue&type=template&id=2f1fa7cc&scoped=true"
import script from "./DevPageKD1.vue?vue&type=script&lang=js"
export * from "./DevPageKD1.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD1.vue?vue&type=style&index=0&id=2f1fa7cc&prod&lang=css"
import style1 from "./DevPageKD1.vue?vue&type=style&index=1&id=2f1fa7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1fa7cc",
  null
  
)

export default component.exports